// ── PLACEHOLDER LINKS ──────────────────────────────────────────────
// HIRING_URL → your hiring-partner contact page or mailto
export const GOOGLE_FORM_EMBED_URL =
  "https://docs.google.com/forms/d/1RwM_gAUtHrD-lBb4CL1nnJwjmvqvEiKrjIe00WSplr4/viewform?embedded=true";
export const GOOGLE_FORM_LINK =
  "https://docs.google.com/forms/d/1RwM_gAUtHrD-lBb4CL1nnJwjmvqvEiKrjIe00WSplr4/viewform";
export const HIRING_URL = "#replace-with-hiring-contact-link";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
